import { dayjs } from "@/helpers/dayjs"
import { toCamel } from '@/utils/convertcase'

export default {
  data() {
    return {
    }
  },
  computed: {
    isCourse() {
      return ['sushi', 'dimsum'].includes(this.eventType)
    },
    isSushiCourse() {
      return this.eventType === 'sushi'
    },
    isDimsumCourse() {
      return this.eventType === 'dimsum'
    },
    isEvent() {
      return this.eventType === 'event'
    },
    isBooking() {
      return this.eventType === 'booking'
    }
  },
  methods: {
    formatDate(date) {
			return dayjs(date).format('dddd, D. MMMM YYYY');
		},
		formatTime(course, startOnly) {
      if (startOnly) {
        return this.$t('course.startOnlyLabel', { timeStart: course.timeStart || course.fromTime })
      }

      return [
        course.timeStart || course.fromTime,
        course.timeStop || course.toTime,
      ].join(' - ');
		},
    formatRegionCode(code) {
			return toCamel(code);
		},
    formatLocation(location) {
      return [
        this.$t(`brands.${location.brand}`),
        location.name,
      ].join(', ')
    },
  },
  mounted() {
  }
}
